export enum IntegrationKey {
  Famous = "famous",
  Plaid = "plaid",
  Payments = "payments",
  OracleFusion = "oracle-fusion",
  Jira = "jira",
  MicrosoftTeams = "microsoft-teams",
  VoiceAgent = "voice-agent",
  Slack = "slack",
}
